export default __webpack_public_path__ + "static/media/landscapeToPortrait.feafb547.webp";